export default function Style(){
    return(
        <style>
            {
                `
                
                `
            }
        </style>
    )
}